<template>
  <div class="ChallengesTechniquesSearchBar">
    <div class="container-fluid">
		  <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 h-100 margin-Top-2Perc margin-bottom-2Perc margin-left-1Perc">   
        <button type="button" class="btn black-border custom-btn white-BG" @click="createNewTechnique($event,true)">+ Create New</button>
      </div> 
      <div class="row col-xs-12 col-sm-12 col-md-12 col-lg-12">
      </div> 
    </div>
    <create-technique-overlay v-if="openOverlay" @openOverlay="UpdateOpenOverlayFlag"></create-technique-overlay>
  </div>
</template>
<script>
import CreateTechniqueOverlay from '@/components/CreateTechniqueOverlay'
export default {
  data: function () {
    return {
      openOverlay: false
    }
  },
  components: {
    'create-technique-overlay': CreateTechniqueOverlay
  },
  methods: {
    createNewTechnique: function (event, flagToUpdate) {
      // AK: Used to open overlay by clicking on Create New
      this.openOverlay = flagToUpdate
      // AK: Disable Background Scrolling
      this.$store.state.isOverlayVisible = flagToUpdate
    },
    UpdateOpenOverlayFlag (value) {
      // AK: Used when use pressed X or after successfully creating Technique
      this.openOverlay = value
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = value
    }
  }
}
</script>
<style scoped>
.display-none {
  display: none;
}
.ChallengesTechniquesSearchBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.font-size-20px
{
  font-size:20px;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.black-border {
  border: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.padding-Left-30px {
  padding-left: 3% !important;
}
.white-BG {
  background-color: #ffffff;
}
.padding-Left-0px {
  padding-left: 0px !important;
}
.margin-left-1Perc{
    margin-left: 1%;
}
.margin-Top-2Perc{
  margin-top:2%;
}
</style>



// WEBPACK FOOTER //
// src/components/ChallengesTechniquesSearchBar.vue